<template>
    <div class="page-home">
        <!-- Hero -->
        <div class="hero">
            <div class="wrapper container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="content">
                        <div class="showMobile">
                          <img src="static/images/bgX.png" style="width:100%;"/>
                        </div>
                          <div class="headline">
                            <h1 class="h1Insights">Insights.
                                <span id="typing"> Analyzed.</span>
                                <span id="typing2"> Optimized.</span>
                                <span id="typing3"> Realized.</span>
                                <span id="typing5"> Multiplied.</span>
                                <span id="typing4"> Multiplied.</span>
                             </h1>
                          </div>
                            <div id="crow"> </div>

                            <p style=";padding-top:70px;">
                                OP'N er er et online værktøj,
                                der giver dig indsigt i din forretning og marketing,
                                så du kan tage de næste træk for din virksomhed.
                            </p>

                            <router-link :to="{name: 'sign-up'}" class="btn btn-primary try-now">
                                Prøv OP'N nu
                            </router-link>
                            
                        </div>
                    </div>
                    <div class="hideMobile" style="position:absolute;right:20%;width:100%;top:90px;">
                      <img src="static/images/bgX.png" style="width:700px;opacity:0.2;"/>
                    </div>
                </div>
            </div>
            <div class="app_download container">
                <a href="https://apps.apple.com/dk/app/opn-by-generaxion/id1568287211" target="_blank">
                    <div class="app_store">
                        <div class="left_wrap">
                            <i class="fa fa-apple" aria-hidden="true"></i>
                        </div>
                        <div class="right_wrap">
                            <p>Tilgængelig på</p>
                            <p>APP Store</p>
                        </div>
                    </div>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.generaxion.opn" target="_blank">
                    <div class="google_play">
                        <div class="left_wrap">
                            <img src="@/assets/googleplay.png"/>
                        </div>
                        <div class="right_wrap">
                            <p>Tilgængelig på</p>
                            <p>Google Play</p>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!-- Highlighted customers -->
        <clients></clients>

        <!-- Dashboard -->
        <div class="dashboard-wrapper">
            <div class="dashboard">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 ml-lg-auto">
                            <div class="content">
                                <h3>
                                    Elegant. Overskueligt. Letforståeligt.
                                    OP'N gør det nemt at drive forretning.
                                </h3>

                                <p>
                                    Med OP'N har vi udviklet et nyt online redskab,
                                    hvor du kan logge ind og se besøg på din hjemmeside,
                                    antal henvendelser, følge dine placeringer på Google,
                                    måle udbyttet af din markedsføring og sammenligne din forretning med andre i branchen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quotes -->
        <quotes></quotes>

        <!-- Integrations -->
        <div class="integrations">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="content text-center">
                            <h3>
                                Forestil dig, at Google, Facebook, Trustpilot og e-conomic<br />
                                gik sammen om at bygge ét fælles dashboard.
                            </h3>

                            <p>
                                OP'N kan integreres med Google, Facebook, Trustpilot, Dinero, e-conomic og mere,
                                hvilket giver dig fuld indsigt i din virksomheds markedsføring og online tilstedeværelse.<br />
                                Er du klar til at tage dit næste træk?
                            </p>

                            <img src="/static/images/integrations.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Sign up -->
        <sign-up></sign-up>
    </div>
</template>

<style lang="scss" scoped>
   @import '~bootstrap/scss/bootstrap.scss';
   $gray-800: #343a40;

    .page-home {
        .hero {
            display: flex;
            flex-direction: column;
            gap:50px;
            width: 100%;
            //height: 80vh;
            //min-height: 70vh;

            background: url('/static/images/tablet-preview.png');
            background-size: auto 70vh;
            background-repeat: no-repeat;
            background-position: right center;

            .headline{
                position:relative;
                overflow:hidden;
            }
            .h1Insights{
            position:relative;
            display:inline-block;
            width:100%;
            }

            .content {

                p {
                    font-weight: 200;
                    font-size: 22px;
                    margin: 30px 0 40px 0;
                }

            }

            @media screen and(min-width: 1196px){
                margin-bottom:50px;
            }

            @include media-breakpoint-down(lg) {
                padding: 50px 0;
                background-size: auto 50vh;
            }

            @include media-breakpoint-down(md) {
                padding: 50px 0;
                background-size: auto 40vh;

                .app_download{
                    display:grid;
                    grid-template-columns: 1fr 1fr;
                    gap:10px;
                }
            }

            @include media-breakpoint-down(sm) {
                background: transparent;
            }

            @media screen and(max-width: 750px){
                gap:0px;
                
                .wrapper{
                    margin-bottom:50px;
                }
            }

            @media screen and(max-width: 446px) {
                gap:0px;
                
                .wrapper{
                    margin-bottom:50px;
                }
                .app_download{
                    display:block;
                    .app_store{
                        margin-bottom:10px;
                    }
                }
            }

            .try-now {
                padding: 15px 25px;
                background-color:#F1A1D9;
                border-color:#F1A1D9;
            }
            #typing {
            width: 0ch;
            color: #F1A1D9;
            position: absolute;
            margin-left: 8px;
            font-family: sans-serif;
            overflow: hidden;
            white-space: nowrap;
            animation: typing 1s steps(50) 0.2s infinite alternate;
            animation-iteration-count:2;
        }
            #typing2 {
            width: 0ch;
            color: #F1A1D9;
            position: absolute;
            margin-left: 8px;
            font-family: sans-serif;
            overflow: hidden;
            white-space: nowrap;
            animation: typing 1s steps(50) 3s infinite alternate;
            animation-iteration-count:2;
        }
            #typing3 {
            width: 0ch;
            color: #F1A1D9;
            position: absolute;
            margin-left: 8px;
            font-family: sans-serif;
            overflow: hidden;
            white-space: nowrap;
            animation: typing 1s steps(50) 5.5s infinite alternate;
            animation-iteration-count:2;
        }
        #typing5 {
        width: 0ch;
        color: #F1A1D9;
        position: absolute;
        margin-left: 8px;
        font-family: sans-serif;
        overflow: hidden;
        white-space: nowrap;
        animation: typing 1s steps(50) 8s infinite alternate;
        animation-iteration-count:1;
    }
        #typing4 {
            animation: cssAnimation 0s 8.5s forwards;
            visibility: hidden;
            color: #F1A1D9;
            position: absolute;
            margin-left: 8px;
            font-family: sans-serif;
            overflow: hidden;
            }

            @keyframes cssAnimation {
            to   { visibility: visible; }
            }
        #typing span{
        color:pink;}

        #crow {
            float: left;

      color: white;
            animation: crow 0.5s linear 0s infinite;
        }
        @keyframes typing {
            from {
                width: 0ch;
            }
            to {
                width: 25ch;
            }
        }
        @keyframes crow {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
        }

        .dashboard-wrapper {
            width: 100%;
            background: url('/static/images/dashboardWrapperPink2.png') center;
            padding: 70px 0;

            .dashboard {
                display: flex;
                align-items: center;

                background: url('/static/images/review-preview.png');
                background-size: 70vh;
                background-repeat: no-repeat;
                background-position: left center;

                width: 100%;
                height: 80vh;
                max-height: 600px;

                .content {
                    margin-top: -20px;
                    color:#fff;

                    p {
                        font-weight: 200;
                        font-size: 22px;
                        margin: 30px 0 0 0 ;
                    }
                }

                @include media-breakpoint-down(md) {
                    background: transparent;
                }

                button {
                    padding: 15px 25px;
                }
            }
        }

        .integrations {
            width: 100%;
            padding: 70px 0;

            h3 {
                margin-bottom: 30px;
            }

            p {
                font-weight: 200;
                font-size: 18px;
                max-width: 80vh;
                margin: 20px auto;
            }

            img {
                width: 1100px;
                max-width: 100%;
                margin-top: 30px;
            }

            @include media-breakpoint-down(md) {
                img {
                    display: none;
                }
            }
        }

        .founder {
            width: 100%;
            height: 80vh;
            background: url('/static/images/founder.png');
            background-size: cover;

            display: flex;
            align-items: center;

            .quote {
                font-size: 25px;
                font-weight: 200;
                margin-bottom: 25px;
            }

            .author {
                font-size: 17px;
                font-weight: 500;

                .employment {
                    font-weight: 200;
                }
            }

            @include media-breakpoint-down(md) {
                background: url('/static/images/founder-mobile.png');
                background-position: center top;
                height: auto;
                padding: 100px 0;
            }
        }
        .app_download{
            position:relative;
            display:flex;
            align-items: center;
            justify-content: start;
            gap:50px;
            a{
                text-decoration: none;
            }

            .google_play, .app_store{
                position:relative;
                z-index: 100;
                cursor: pointer;
                background:$gray-800;
                background-image: linear-gradient(to right, $gray-800, lighten($gray-800, 5%));
                padding:15px 25px;
                min-width:200px;
                min-height:100%;
                
                border-radius:.25rem;
                display:flex;
                align-items: center;
                justify-content: space-between;

                transition: background 300ms ease-in-out;

                &:hover{
                    background: $gray-800;
                }
                .left_wrap{
                    flex:1;
                    i{
                        color:white;
                        font-size:45px;
                    }
                    img{
                        width:35px;
                    }
                }
                .right_wrap{
                    flex:2;
                    p{
                        user-select: none;
                        color:white;
                        margin:0;
                        font-size:14px;
                    }
                    p:nth-of-type(2){
                        font-size:18px;
                        font-weight: bold;
                    }
                }
            }
        }
    }
</style>

<script>
    import Clients from '@/components/Clients'
    import Quotes from '@/components/Quotes'
    import SignUp from '@/components/SignUp'

    export default {
        components: {
            Clients,
            Quotes,
            SignUp
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue